<template>
  <main class="error">
    <p class="error__msg">
      <template v-for="(message, index) in errorMessage" :key="index">
        {{ message }}<br v-if="index !== errorMessage.length - 1" />
      </template>
    </p>
    <button id="retry-btn" class="error__btn" @click="handlerClose">닫기</button>
  </main>
</template>
<script setup lang="ts">
import type { NuxtError } from '#app'

type PropsType = {
  error: NuxtError
}

const props = defineProps<PropsType>()

const errorMessage = computed(() => {
  return props.error?.statusMessage
    ? [props.error?.statusMessage]
    : ['문제가 발생했어요.', '잠시 후 다시 시도해 주세요.']
})

const handlerClose = () => {
  nativeCloseWindow({ result: false })
}
</script>
<style lang="scss" scoped>
.error {
  display: flex;
  height: 100dvh;
  flex-flow: column;
  align-items: center;
  padding-top: 128px;
  &__msg {
    margin-bottom: 24px;
    line-height: 21px;
    font-size: 15px;
    text-align: center;
  }
  &__btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    padding: 0 20px;
    height: 48px;
    line-height: 1;
    font-size: 16px;
    font-weight: 500;
    border-radius: 24px;
    text-decoration: none;
    border: 3px solid transparent;
  }
}

@media (prefers-color-scheme: light) {
  .error {
    background: #fff;
    &__msg {
      color: #7f7f7f;
    }
    &__btn {
      background: #f5f5f5;
      color: #1a1a1a;
      background-clip: padding-box;
    }
  }
}

@media (prefers-color-scheme: dark) {
  .error {
    background: #111;
    &__msg {
      color: #7f7f7f;
    }
    &__btn {
      background: #1a1a1a;
      color: #e4e4e4;
      background-clip: padding-box;
    }
  }
}
</style>
